module.exports = __webpack_public_path__ + "media/images/pic/courses/2-ba01ca23ea17706d8d43cdcd6c94e345.jpeg";